module.exports = __webpack_public_path__ + "img/box4_bg_light.03453949.png";